import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, catchError, tap } from 'rxjs';
import { GetCompanyDetail, UpdateCompanyDetail } from '../actions/company.detail.action';
import {
  AddProgressBarWorkflowStack,
  RemoveProgressBarWorkflowStack,
} from '../actions/progress-bar-workflow.action';
import { ApiService } from '../services/api-service/api.service';
import { CompanyProfileRequest } from '../types/company-profile';
import { PersonalProfileState } from './personal-profile.state';

export interface CompanyDetailStateModel {
  detail: CompanyProfileRequest;
}

@State<CompanyDetailStateModel>({
  name: 'companyDetail',
  defaults: {
    detail: {} as CompanyProfileRequest,
  },
  children: [PersonalProfileState],
})
@Injectable()
export class CompanyDetailState {
  constructor(private apiService: ApiService) {}

  @Selector()
  static getCompanyDetail(state: CompanyDetailStateModel) {
    return state.detail;
  }

  @Action(GetCompanyDetail)
  fetchCompanyDetail(ctx: StateContext<CompanyDetailStateModel>) {
    ctx.dispatch(new AddProgressBarWorkflowStack({ uniqueId: 'GetCompanyDetail' }));
    return this.apiService.getCall<CompanyProfileRequest>('orgs/fetch-company-info/').pipe(
      tap((response: CompanyProfileRequest) => {
        ctx.patchState({
          detail: response,
        });

        ctx.dispatch(
          new RemoveProgressBarWorkflowStack({
            uniqueId: 'GetCompanyDetail',
          }),
        );
      }),
      catchError<unknown, Observable<boolean>>((_err) => {
        ctx.dispatch(
          new RemoveProgressBarWorkflowStack({
            uniqueId: 'GetCompanyDetail',
          }),
        );
        throw _err;
      }),
    );
  }

  @Action(UpdateCompanyDetail)
  updatePersonalProfile(ctx: StateContext<CompanyDetailStateModel>, action: UpdateCompanyDetail) {
    ctx.dispatch(new AddProgressBarWorkflowStack({ uniqueId: 'UpdateCompanyDetail' }));
    return this.apiService.postCall(`orgs/add-company-info`, action.payload).pipe(
      tap(() => {
        ctx.dispatch(
          new RemoveProgressBarWorkflowStack({
            uniqueId: 'UpdateCompanyDetail',
          }),
        );
      }),
      catchError<unknown, Observable<boolean>>((_err) => {
        ctx.dispatch(
          new RemoveProgressBarWorkflowStack({
            uniqueId: 'UpdateCompanyDetail',
          }),
        );
        throw _err;
      }),
    );
  }
}
